import _ from "lodash";
import { api } from "../../server/request";
import { handleError, handleResponse } from "../../actions/responseUtil";
import { User } from "./types";

export const ACTION_TYPES = {
    SET_LOADING: "starlinkReports/setLoading",
    GET_ASSETS: "starlinkReports/getAssets",
    GET_ASSETS_PLAN_USAGE: "starlinkReports/getAssetsPlanUsage",
    GET_ASSETS_CSV: "starlinkReports/getAssetsCSV",
    GET_ASSET_USAGE: "starlinkReports/getAssetUsage",
    GET_ASSET_CURRENT_BILLING_CYCLE_USAGE: "starlinkReports/getAssetCurrentBillingCycleUsage",
    GET_ALL_SERVICE_LINES: "starlinkReports/getAllServiceLines",
    GET_QUOTA_AVAILABLITY_ALERT: "starlinkReports/getQuotaAvailabilityAlert",
    GET_STARLINK_ASSET_USAGE_SPLIT: "starlinkAdmin/getAssetUsageSplit",
    GET_STARLINK_ASSET_PLAN_USAGE_SPLIT: "starlinkAdmin/getAssetPlanUsageSplit",
    GET_STARLINK_USAGE_POOL_PLANS_CHART: "starlinkReports/getStarlinkUsagePoolPlansChart",
    GET_STARLINK_USAGE_SERVICE_LINES_CHART: "starlinkReports/getStarlinkUsagePoolServiceLinesChart",
    GET_STARLINK_USAGE_TOP_WIDGET: "starlinkReports/getStarlinkUsageTopWidget",
    GET_STARLINK_PLAN_USAGE_HIERARCHY: "starlinkReports/getStarlinkPlanUsageHierarchy",
    GET_STARLINK_USAGE_POOL_PLANS_CHART_LOADING: "starlinkReports/getStarlinkUsagePoolPlansChart/loading",
    GET_STARLINK_USAGE_SERVICE_LINES_CHART_LOADING: "starlinkReports/getStarlinkUsagePoolServiceLinesChart/loading",
    GET_STARLINK_USAGE_TOP_WIDGET_LOADING: "starlinkReports/getStarlinkUsageTopWidget/loading",
    GET_STARLINK_PLAN_USAGE_HIERARCHY_LOADING: "starlinkReports/getStarlinkPlanUsageHierarchy/loading",
}

const initialState = {
    assets: [],
    assetsPlanUsage: [],
    allServiceLines: [],
    assetsCSV: [],
    assetUsage: {},
    totalAssets: 0,
    totalAssetsPlanUsage: 0,
    gettingAssets: false,
    gettingAssetsPlanUsage: false,
    gettingAssetsCSV: false,
    gettingAssetUsage: false,
    gettingAssetCurrentBillingCycleUsage: false,
    settingQuotaAlert: false,
    settingAvailabilityAlert: false,
    quotaAvailablityAlerts:[],
    assetUsageSplit:{},
    assetPlanUsageSplit: {},
    starlinkUsagePoolPlansChart: {},
    starlinkUsagePoolServiceLinesChart: {},
    starlinkUsageTopWidget: {},
    starlinkPlanUsageHierarchy: {},
    gettingStarlinkUsagePoolPlansChart: false,
    gettingStarlinkUsagePoolServiceLinesChart: false,
    gettingStarlinkUsageTopWidget: false,
    gettingStarlinkPlanUsageHierarchy: false,
}

export function StarlinkReportsReducer(state: any = initialState, action) {
    switch (action.type) {
        case ACTION_TYPES.GET_ASSETS: {
            const assets = action?.payload?.data ? action?.payload?.data : [];
            return {
                ...state,
                assets: assets && assets.length > 0 ? assets :  [],
                totalAssets:  assets && assets.length > 0 ? assets[0]?.total_count :  0,
            }
        }
        case ACTION_TYPES.GET_ASSETS_PLAN_USAGE: {
            let assets = action?.payload?.data;
            try {
                assets = assets;
            } catch (error) {
                assets = [];
            }
            return {
                ...state,
                assetsPlanUsage: Array.isArray(assets) && assets?.length > 0 ? assets : [],
                totalAssetsPlanUsage: Array.isArray(assets) && assets?.length > 0 ? assets[0]?.total_count : 0,
            };
        }
        case ACTION_TYPES.GET_ASSETS_CSV: {
            const [csv] = action.payload?.data?.rows?.[0];
            return {
                ...state,
                assetsCSV: csv || [],
            }
        }
        case ACTION_TYPES.GET_ASSET_USAGE: {
            return {
                ...state,
                assetUsage: action.payload?.data?.total_gb?.series || {},
            }
        }
        case ACTION_TYPES.GET_ALL_SERVICE_LINES: {
            const allServiceLines = action.payload?.data;
            return {
                ...state,
                allServiceLines: allServiceLines || [],
            }
        }
        case ACTION_TYPES.GET_QUOTA_AVAILABLITY_ALERT: {
            const alert = action.payload?.data?.rows[0][0];
            return {
                ...state,
                quotaAvailablityAlerts: alert || [],
            }
        }
        case ACTION_TYPES.SET_LOADING: {
            return {
                ...state,
                ...action.payload
            }
        }
        case ACTION_TYPES.GET_STARLINK_USAGE_POOL_PLANS_CHART_LOADING: {
            return {
                ...state,
                ...action.payload
            }
        }
        case ACTION_TYPES.GET_STARLINK_USAGE_SERVICE_LINES_CHART_LOADING: {
            return {
                ...state,
                ...action.payload
            }
        }
        case ACTION_TYPES.GET_STARLINK_USAGE_TOP_WIDGET_LOADING: {
            return {
                ...state,
                ...action.payload
            }
        }
        case ACTION_TYPES.GET_STARLINK_PLAN_USAGE_HIERARCHY_LOADING: {
            return {
                ...state,
                ...action.payload
            }
        }
        case ACTION_TYPES.GET_STARLINK_ASSET_USAGE_SPLIT: {
            return {
                ...state,
                assetUsageSplit: action.payload?.data?.usage_value?.series,
            }
        }
        case ACTION_TYPES.GET_STARLINK_ASSET_PLAN_USAGE_SPLIT: {
            return {
                ...state,
                assetPlanUsageSplit: action.payload?.data?.usage_value?.series,
            }
        }
        case ACTION_TYPES.GET_STARLINK_USAGE_POOL_PLANS_CHART: {
            return {
                ...state,
                starlinkUsagePoolPlansChart: action.payload?.data
            }
        }
        case ACTION_TYPES.GET_STARLINK_USAGE_SERVICE_LINES_CHART: {
            return {
                ...state,
                starlinkUsagePoolServiceLinesChart: action.payload?.data
            }
        }
        case ACTION_TYPES.GET_STARLINK_USAGE_TOP_WIDGET: {
            return {
                ...state,
                starlinkUsageTopWidget: action.payload?.data
            }
        }
        case ACTION_TYPES.GET_STARLINK_PLAN_USAGE_HIERARCHY: {
            return {
                ...state,
                starlinkPlanUsageHierarchy: action.payload?.data ? action.payload?.data : []
            }
        }
        default:
            return state
    }
}

export interface getAssetParameters {
    dpIds: string[];
    searchText: string;
    chartStartDate: string;
    chartEndDate: string;
    sortBy: string;
    sortOrder: string;
    page: number;
    limit: number;
    usageSource:String;
    serviceLines: any;
    accounts:any;
    non_billable: number;
    standard: number;
    priority: number;
    opt_in_priority:number;
}

export interface getPlanUsageAssetParameters {
    selectedFilter: any;
    dpIds: string[];
    searchText: string;
    chartStartDate: string;
    chartEndDate: string;
    sortBy: string;
    sortOrder: string;
    page: number;
    limit: number;
    usageSource:String;
    serviceLines: any;
    accounts:any;
    usageFilter:any;
    parent_pool_id: string;
    id: string;
    type: string;
    account_number: string;
    filters: any;
} 



export const getAssets = (parameters) => (dispatch) => {
    clearComponentData()
    if (_.isEmpty(parameters?.dpIds)) return;
    if (parameters?.serviceLines?.includes('All') ) return;
    dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingAssets: true } });
    dispatch({ type: ACTION_TYPES.GET_ASSETS, payload: null});
    let _parameters: any = {
        dpIds: parameters.dpIds.map(dpId => `'${dpId}'`).join(','),
        accountNumbers: parameters?.accounts?.length ? parameters?.accounts?.map(acc => `'${acc}'`).join(',') : "''",
        serviceLines:  parameters?.serviceLines?.length ? parameters?.serviceLines?.map(sl => `'${sl}'`).join(',')  : "''",
        searchText: parameters?.searchText,
        chartStartDate: parameters?.chartStartDate,
        chartEndDate: parameters?.chartEndDate,
        sortBy: parameters?.sortBy,
        sortOrder: parameters?.sortOrder,
        limit: parameters?.limit,
        usageSource: parameters?.usageSource,
        offset: (parameters?.page - 1) * parameters?.limit,
        non_billable:  parameters?.non_billable,
        standard: parameters?.standard,
        priority: parameters?.priority,
        opt_in_priority:  parameters?.opt_in_priority,
    };
    const data = {
        query: `OPT_GET_STARLINK_ASSETS_CH_V3`,
        named: true,
        format: 'json',
        parameters: _parameters
    }
    api
        .postRequestOut(`/store/ch/query`, data)
        .then((res) => {
            handleResponse(res, dispatch, ACTION_TYPES.GET_ASSETS)
            dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingAssets: false } });
        })
        .catch((err) => {
            handleError(err, dispatch);
            dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingAssets: false } });
        });
}

export interface getAssetsCSVParameters {
    dpIds: string[];
    searchText: string;
    sortBy: string;
    sortOrder: string;
    accounts:any;
}

export const getAssetsCSV = (parameters: getAssetsCSVParameters) => async (dispatch) => {
    return new Promise<void>((resolve, reject) => {
        if (_.isEmpty(parameters?.dpIds)) return;
        dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingAssetsCSV: true } });
        let _parameters: any = {
            dpIds: parameters.dpIds.map(dpId => `'${dpId}'`).join(','),
            searchText: parameters.searchText,
            sortBy: parameters.sortBy,
            sortOrder: parameters.sortOrder
        };
        const data = {
            query: `GET_STARLINK_ASSETS_CSV`,
            named: true,
            format: 'csv',
            parameters: _parameters
        }
        api
            .postRequestOut(`/store/ss/query`, data)
            .then((res) => {
                handleResponse(res, dispatch, ACTION_TYPES.GET_ASSETS_CSV)
                dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingAssetsCSV: false } });
                resolve();
            })
            .catch((err) => {
                handleError(err, dispatch);
                dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingAssetsCSV: false } });
                reject(err);
            });
    })
}

export const getAssetUsageCharts = (parameters) => (dispatch) => {
    if (_.isEmpty(parameters?.dpIds)) return;
    if (parameters?.serviceLines?.includes('All') ) return;
    dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingServiceLines: true } });

    let _parameters = {
        dpIds: parameters.dpIds.map(dpId => `'${dpId}'`).join(','),
        accountNumbers: parameters?.accounts?.length ? parameters?.accounts?.map(acc => `'${acc}'`).join(',') : "''",
        serviceLines:  parameters?.serviceLines?.length ? parameters?.serviceLines?.map(sl => `'${sl}'`).join(',')  : "''",
        startDate: parameters.startDate,
        endDate: parameters.endDate,
        source: parameters.source,
        includeInactive: parameters?.includeInactiveServiceLines ? 1 : 0
    };

    const data = {
        query: `OPT_GET_STARLINK_ASSET_USAGE_SPLIT_V2`,
        named: true,
        format: 'chart',
        groupBy: "usage_type",
        tsColumn: "date",
        series: "usage_value",
        annotation: "asset_name",
        parameters: _parameters
    }
    api
        .postRequestOut(`/store/ch/query`, data)
        .then((res) => {
            handleResponse(res, dispatch, ACTION_TYPES.GET_STARLINK_ASSET_USAGE_SPLIT)
            dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingServiceLines: false } });
        })
        .catch((err) => {
            handleError(err, dispatch);
            dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingServiceLines: false } });
        });
}

export interface getAssetUsageParameters {
    dpIds: string[];
    startDate: string;
    endDate: string;
    source:string;
    serviceLines:string[];
    accounts: any;
    includeInactiveServiceLines?: boolean;
}

export interface getAssetPlanUsageParameters {
    selectedFilter: any;
    filters: any;
    dpIds: string[];
    startDate: string;
    endDate: string;
    source:string;
    serviceLines:any;
    accounts: any;
    parent_pool_id: string;
    id: string;
    type: string;
    account_number: string;
}

export const getAssetUsage = (parameters: getAssetUsageParameters) => (dispatch) => {
    clearComponentData()
    // if (_.isEmpty(parameters?.dpIds)) return;
    if (_.isEmpty(parameters?.serviceLines)) return;
    if (parameters?.serviceLines?.includes('All') ) return;
    dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingAssetUsage: true } });
    let _parameters = {
        // dpIds: parameters.dpIds.map(dpId => `'${dpId}'`).join(','),
        startDate: parameters.startDate,
        endDate: parameters.endDate,
        source: parameters.source,
        serviceLines: parameters.serviceLines.map(sl => `'${sl}'`).join(',')
    };
    const data = {
        query: `GET_STARLINK_ASSET_USAGE`,
        named: true,
        format: 'chart',
        groupBy: "asset_number",
        tsColumn: "date",
        series: "total_gb",
        annotation: "asset_name",
        parameters: _parameters
    }
    api
        .postRequestOut(`/store/ch/query`, data)
        .then((res) => {
            handleResponse(res, dispatch, ACTION_TYPES.GET_ASSET_USAGE)
            dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingAssetUsage: false } });
        })
        .catch((err) => {
            handleError(err, dispatch);
            dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingAssetUsage: false } });
        });
}

export const getQuotaAvailablityAlert = (parameters) => (dispatch) => {
    if (_.isEmpty(parameters?.serviceLineNumber)) return;
    dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingAssetUsage: true } });
    let _parameters = { serviceLineNumber: parameters.serviceLineNumber.map(sl => `'${sl}'`).join(',') };
    const data = {
        query: `GET_QUOTA_AND_AVAILABLITY_ALERTS`,
        named: true,
        format: 'csv',
        parameters: _parameters
    }
    api
        .postRequestOut(`/store/pg/query`, data)
        .then((res) => {
            handleResponse(res, dispatch, ACTION_TYPES.GET_QUOTA_AVAILABLITY_ALERT);
            dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingAssetUsage: false } });
        })
        .catch((err) => {
            handleError(err, dispatch);
            dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingAssetUsage: false } });
        });
}

export interface getAssetCurrentBillingCycleUsageParameters {
    assetNumbers: string[];
}

export const getAssetCurrentBillingCycleUsage = (parameters: getAssetCurrentBillingCycleUsageParameters) => (dispatch) => {
    if (_.isEmpty(parameters?.assetNumbers)) return;

    dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingAssetCurrentBillingCycleUsage: true } });
    let _parameters: any = { asset_numbers: parameters.assetNumbers.map(assetNumber => `'${assetNumber}'`).join(',') };
    const data = {
        query: "GET_STARLINK_ASSET_CURRENT_BILLING_CYCLE_USAGE",
        named: true,
        format: 'csv',
        parameters: _parameters
    }
    api
        .postRequestOut(`/store/ss/query`, data)
        .then((res) => {
            handleResponse(res, dispatch, ACTION_TYPES.GET_ASSET_CURRENT_BILLING_CYCLE_USAGE)
            dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingAssetCurrentBillingCycleUsage: false } });
        })
        .catch((err) => {
            handleError(err, dispatch);
            dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingAssetCurrentBillingCycleUsage: false } });
        });
}

export interface getAllServiceLinesParameters {
    dpIds: string[];
    serviceLines: string[];
}

export const getAllServiceLines = (parameter: getAllServiceLinesParameters) => (dispatch) => {
    if (_.isEmpty(parameter?.serviceLines)) return;
    if (parameter?.serviceLines?.includes('All') ) return;
    let _parameters = { 
        serviceLines: parameter?.serviceLines?.map(sl => `'${sl}'`).join(',') };
    const data = {
        query: `GET_ALL_STARTLINK_SERVICE_LINE`,
        named: true,
        format: 'json',
        parameters: _parameters
    }
    api
        .postRequestOut(`/store/ch/query`, data)
        .then((res) => {
            handleResponse(res, dispatch, ACTION_TYPES.GET_ALL_SERVICE_LINES)
        })
        .catch((err) => {
            handleError(err, dispatch);
        });
}

export interface setQuotaAlertParameters {
    serviceLineNumbers: string[];
    alertingThresholds: number[];
    notificationMethods: string[];
    usersToNotify: User[];
}

export const setQuotaAlert = (parameters: setQuotaAlertParameters) => async (dispatch) => {
    if (_.isEmpty(parameters?.serviceLineNumbers)) return;
    dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { settingQuotaAlert: true } });
    try {
        let res = await api.starlink.post('/alerts/quotas/bulk', parameters)
        dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { settingQuotaAlert: false } });
        return res;
    } catch (error) {
        dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { settingQuotaAlert: false } });
        return null;
    }
}

export interface setAvailabilityAlertParameters {
    serviceLineNumbers: string[];
    alertingThreshold: string;
    notificationMethods: string[];
    usersToNotify: User[];
}

export const setAvailabilityAlert = (parameters: setAvailabilityAlertParameters) => async (dispatch) => {
    if (_.isEmpty(parameters?.serviceLineNumbers)) return;
    dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { settingAvailabilityAlert: true } });
    try {
        let res = await api.starlink.post('/alerts/availability/bulk', parameters)
        dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { settingAvailabilityAlert: false } });
        return res;
    } catch (error) {
        dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { settingAvailabilityAlert: false } });
        return null;
    }
}

export const clearCSV = () => (dispatch) => {
    dispatch({ type: ACTION_TYPES.GET_ASSETS_CSV, payload: { data: { rows: [[]] } } })
}

export const clearComponentData = () => (dispatch) => {
    dispatch({ type: ACTION_TYPES.GET_ASSETS, payload: { data: { rows: [[[], 0]] } } })
    dispatch({ type: ACTION_TYPES.GET_ASSET_USAGE, payload: { data: { total_gb: { series: {} } } } })
    dispatch({ type: ACTION_TYPES.GET_ASSETS_CSV, payload: { data: { rows: [[]] } } })
}

export const getStarlinkUsagePoolPlansChart = (parent_pool_id, startDate, endDate, source, id, type, account_number, selectedFilter, filters, page) => (dispatch) => {
    if(_.isEmpty(account_number) || _.isEmpty(id) || _.isEmpty(type) ) return
    dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingStarlinkUsagePoolPlansChart: true } });
    const selectedValues: any = [].concat(selectedFilter || []);
    const isStandard = selectedValues?.includes('standard');
    const isTotalUsage = selectedValues?.includes('total_usage');
    const hasMonthly = filters.planduration.includes("Monthly");
    const hasYearly = filters.planduration.includes("Yearly");
    const dur = hasMonthly && hasYearly ? "'monthly','yearly'" : hasMonthly ? "'monthly'" : hasYearly ? "'yearly'" : "'monthly','yearly'";
    const plansChart: any = {
        query: 'GET_STARLINK_USAGE_POOL_PLANS_CHART_V2',
        named: true,
        format: "json",
        parameters: {
            parent_pool_id: parent_pool_id,
            from_date: startDate,
            to_date: endDate,
            usage_source: source,
            id,
            type,
            account_number: account_number,
            opt_in_priority: filters.datatype.includes("OptinPriority") ? 1 : 0,
            priority: filters.datatype.includes("Priority") ? 1 : 0,
            standard: filters.datatype.includes("Standard") ? 1 : 0,
            non_billable: filters.datatype.includes("NonBillable") ? 1 : 0,
            duration: dur,
            offset: ((page - 1) * 10),
            limit: 10
        }
    }
    return api
        .postRequestOut(`/store/pg/query`, plansChart)
        .then((res) => {
            handleResponse(res, dispatch, ACTION_TYPES.GET_STARLINK_USAGE_POOL_PLANS_CHART)
            dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingStarlinkUsagePoolPlansChart: false } });
        })
        .catch((err) => {
            handleError(err, dispatch);
            dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingStarlinkUsagePoolPlansChart: false } });
        });
};

export const getStarlinkUsagePoolServiceLinesChart = (parent_pool_id, startDate, endDate, source, id, type, account_number, selectedFilter, filters, page) => (dispatch) => {
    if ( _.isEmpty(account_number) || _.isEmpty(type) ) return;
    dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingStarlinkUsagePoolServiceLinesChart: true } });
    const selectedValues: any = [].concat(selectedFilter || []);
    const isStandard = selectedValues?.includes('standard');
    const isTotalUsage = selectedValues?.includes('total_usage');
    const hasMonthly = filters.planduration.includes("Monthly");
    const hasYearly = filters.planduration.includes("Yearly");
    const dur = hasMonthly && hasYearly ? "'monthly','yearly'" : hasMonthly ? "'monthly'" : hasYearly ? "'yearly'" : "'monthly','yearly'";
    const linesChart: any = {
        query: 'GET_STARLINK_USAGE_SERVICE_LINES_CHART_V2',
        named: true,
        format: "json",
        parameters: {
            parent_pool_id: parent_pool_id,
            from_date: startDate,
            to_date: endDate,
            usage_source: source,
            id,
            type,
            account_number: account_number,
            opt_in_priority: filters.datatype.includes("OptinPriority") ? 1 : 0,
            priority: filters.datatype.includes("Priority") ? 1 : 0,
            standard: filters.datatype.includes("Standard") ? 1 : 0,
            non_billable: filters.datatype.includes("NonBillable") ? 1 : 0,
            duration: dur,
            offset: ((page - 1) * 10),
            limit: 10
        }
    }
    return api
        .postRequestOut(`/store/pg/query`, linesChart)
        .then((res) => {
            handleResponse(res, dispatch, ACTION_TYPES.GET_STARLINK_USAGE_SERVICE_LINES_CHART)
            dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingStarlinkUsagePoolServiceLinesChart: false } });
        })
        .catch((err) => {
            handleError(err, dispatch);
            dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingStarlinkUsagePoolServiceLinesChart: false } });
        });
};

export const getStarlinkPlanUsageTopWidget = (parent_pool_id, dp_id, id, type, account_number, selectedFilter, filters, ) => (dispatch) => {
    if(_.isEmpty(account_number) || _.isEmpty(dp_id) || _.isEmpty(id) ||_.isEmpty(type) ) return
    dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingStarlinkUsageTopWidget: true } });
    const selectedValues: any = [].concat(selectedFilter || []);
    const isStandard = selectedValues?.includes('standard');
    const isTotalUsage = selectedValues?.includes('total_usage');
    const hasMonthly = filters.planduration.includes("Monthly");
    const hasYearly = filters.planduration.includes("Yearly");
    const dur = hasMonthly && hasYearly ? "'monthly','yearly'" : hasMonthly ? "'monthly'" : hasYearly ? "'yearly'" : "'monthly','yearly'";
    const linesChart: any = {
        query: 'GET_STARLINK_PLAN_USAGE_TOP_CARD_V2',
        named: true,
        format: "json",
        parameters: {
            parent_pool_id: parent_pool_id,
            dp_id: dp_id,
            id: id,
            type: type,
            account_number: account_number,
            opt_in_priority: filters.datatype.includes("OptinPriority") ? 1 : 0,
            priority: filters.datatype.includes("Priority") ? 1 : 0,
            standard: filters.datatype.includes("Standard") ? 1 : 0,
            non_billable: filters.datatype.includes("NonBillable") ? 1 : 0,
            duration: dur
        }
    }
    api
        .postRequestOut(`/store/pg/query`, linesChart)
        .then((res) => {
            handleResponse(res, dispatch, ACTION_TYPES.GET_STARLINK_USAGE_TOP_WIDGET)
            dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingStarlinkUsageTopWidget: false } });
        })
        .catch((err) => {
            handleError(err, dispatch);
            dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingStarlinkUsageTopWidget: false } });
        });
};

export const getStarlinkPlanUsageHierarchy = (parameters: any) => (dispatch) => {
    dispatch({ type: ACTION_TYPES.GET_STARLINK_PLAN_USAGE_HIERARCHY, payload: { data: [] } });
    dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingStarlinkPlanUsageHierarchy: true } });
    const selectedValues: any = [].concat(parameters.selectedFilter || []);
    const isStandard = selectedValues?.includes('standard');
    const isTotalUsage = selectedValues?.includes('total_usage');
    const hasMonthly = parameters.filters.planduration.includes("Monthly");
    const hasYearly = parameters.filters.planduration.includes("Yearly");
    const dur = hasMonthly && hasYearly ? "'monthly','yearly'" : hasMonthly ? "'monthly'" : hasYearly ? "'yearly'" : "'monthly','yearly'";
    let _parameters = {
        dp_id: parameters.dpId,
        plan_filter: parameters.plan_filter,
        start_date: parameters.startDate,
        opt_in_priority: parameters.filters.datatype.includes("OptinPriority") ? 1 : 0,
        priority: parameters.filters.datatype.includes("Priority") ? 1 : 0,
        standard: parameters.filters.datatype.includes("Standard") ? 1 : 0,
        non_billable: parameters.filters.datatype.includes("NonBillable") ? 1 : 0,
        duration: dur
    };
    const data = {
        query: `GET_STARLINK_USAGE_PLAN_HIERARCHY_V5`,
        named: true,
        format: 'json',
        parameters: _parameters
    }
    api
        .postRequestOut(`/store/pg/query`, data)
        .then((res) => {
            handleResponse(res, dispatch, ACTION_TYPES.GET_STARLINK_PLAN_USAGE_HIERARCHY)
            dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingStarlinkPlanUsageHierarchy: false } });
        })
        .catch((err) => {
            handleError(err, dispatch);
            dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingStarlinkPlanUsageHierarchy: false } });
        });
}

export const getAssetPlanUsageCharts = (parameters: getAssetPlanUsageParameters) => (dispatch) => {
    if (_.isEmpty(parameters?.serviceLines) || _.isEmpty(parameters?.dpIds) || _.isEmpty(parameters?.account_number) || _.isEmpty(parameters?.type) ) return;
    if (parameters?.serviceLines?.includes('All') ) return;
    dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingPlanServiceLines: true } });
    const hasMonthly = parameters?.filters?.planduration.includes("Monthly");
    const hasYearly = parameters?.filters?.planduration.includes("Yearly");
    const dur = hasMonthly && hasYearly ? "'monthly','yearly'" : hasMonthly ? "'monthly'" : hasYearly ? "'yearly'" : "'monthly','yearly'";
    let _parameters = {
        dp_id: parameters.dpIds,
        source: "direct_source",
        id: parameters.id,
        type: parameters.type,
        opt_in_priority: parameters.filters?.datatype.includes("OptinPriority") ? 1 : 0,
        priority: parameters.filters?.datatype.includes("Priority") ? 1 : 0,
        standard: parameters.filters?.datatype.includes("Standard") ? 1 : 0,
        non_billable: parameters.filters?.datatype.includes("NonBillable") ? 1 : 0,
        duration: dur,
        accountNumbers: parameters?.accounts,
        serviceLines: parameters?.serviceLines,
    };

    const data = {
        query: `OPT_GET_STARLINK_ASSET_PLAN_USAGE_SPLIT`,
        named: true,
        format: "chart",
        groupBy: "usage_type",
        tsColumn: "date",
        series: "usage_value",
        annotation: "asset_name",
        parameters: _parameters
    }
    api
        .postRequestOut(`/store/ch/query`, data)
        .then((res) => {
            handleResponse(res, dispatch, ACTION_TYPES.GET_STARLINK_ASSET_PLAN_USAGE_SPLIT)
            dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingPlanServiceLines: false } });
        })
        .catch((err) => {
            handleError(err, dispatch);
            dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingPlanServiceLines: false } });
        });
}

export const getAssetsPlanUsage = (parameters: getPlanUsageAssetParameters) => (dispatch) => {
    if( _.isEmpty(parameters?.dpIds) || _.isEmpty(parameters?.id) || _.isEmpty(parameters?.type) ) return
    clearComponentData()
    if (parameters?.serviceLines?.includes('All') ) return;
    dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingAssetsPlanUsage: true } });
    dispatch({ type: ACTION_TYPES.GET_ASSETS, payload: null});
    const selectedValues: any = [].concat(parameters.selectedFilter || []);
    const isStandard = selectedValues?.includes('standard');
    const isTotalUsage = selectedValues?.includes('total_usage');
    const hasMonthly = parameters?.filters?.planduration.includes("Monthly");
    const hasYearly = parameters?.filters?.planduration.includes("Yearly");
    const dur = hasMonthly && hasYearly ? "'monthly','yearly'" : hasMonthly ? "'monthly'" : hasYearly ? "'yearly'" : "'monthly','yearly'";
    let _parameters: any = {
        searchText: parameters?.searchText,
        sortBy: parameters?.sortBy,
        sortOrder: parameters?.sortOrder,
        limit: parameters?.limit,
        offset: (parameters?.page - 1) * parameters?.limit,
        usage_filter: parameters?.usageFilter,
        id: parameters.id,
        type: parameters.type,
        accountNumbers: parameters?.accounts,
        dp_id: parameters?.dpIds,
        opt_in_priority: parameters.filters?.datatype.includes("OptinPriority") ? 1 : 0,
        priority: parameters.filters?.datatype.includes("Priority") ? 1 : 0,
        standard: parameters.filters?.datatype.includes("Standard") ? 1 : 0,
        non_billable: parameters.filters?.datatype.includes("NonBillable") ? 1 : 0,
        serviceLines:   parameters?.serviceLines,
        duration: dur
    };
    const data = {
        query: `OPT_GET_STARLINK_ASSETS_PLAN_USAGE_CH`,
        named: true,
        format: 'json',
        parameters: _parameters
    }
    api
        .postRequestOut(`/store/ch/query`, data)
        .then((res) => {
            handleResponse(res, dispatch, ACTION_TYPES.GET_ASSETS_PLAN_USAGE)
            dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingAssetsPlanUsage: false } });
        })
        .catch((err) => {
            handleError(err, dispatch);
            dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingAssetsPlanUsage: false } });
        });
}